import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiGmail } from "react-icons/si";

const iconClass =
  "min-w-7 min-h-7 sm:min-w-10 sm:min-h-10 hover:text-red-500 duration-300";

function Socials() {
  return (
    <div id="buttons" className="flex flex-row pt-5 gap-2">
      <a
        href="https://github.com/Datlightning"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="GitHub"
      >
        <FaGithub className={iconClass} />
      </a>
      <a href="mailto:vihas.veggalam@utexas.edu" aria-label="Email">
        <SiGmail className={iconClass} />
      </a>
      <a
        href="https://www.linkedin.com/in/vihas-veggalam-1a64702b1/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
      >
        <FaLinkedin className={iconClass} />
      </a>
    </div>
  );
}

export default Socials;
